(function() {
  'use strict';

  class MtAnimationSlideshow {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-slideshow-dot]'));
      this.prevBtn = root.querySelector('[data-slideshow-prev]');
      this.nextBtn = root.querySelector('[data-slideshow-next]');
      this.activeIndex = 0;
      this.destroyed = false;

      if (!this.slides.length) {
        this.destroyed = true;
        return;
      }

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDotClick = this.onDotClick.bind(this);

      this.init();
    }

    init() {
      this.updateSlides();
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', this.onPrev);
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', this.onNext);
      }
      this.dots.forEach((dot) => {
        dot.addEventListener('click', this.onDotClick);
      });
    }

    onPrev(event) {
      event.preventDefault();
      this.goTo(this.activeIndex - 1);
    }

    onNext(event) {
      event.preventDefault();
      this.goTo(this.activeIndex + 1);
    }

    onDotClick(event) {
      event.preventDefault();
      const dot = event.currentTarget;
      const index = parseInt(dot.getAttribute('data-slideshow-dot'), 10);
      if (!Number.isNaN(index)) {
        this.goTo(index);
      }
    }

    goTo(index) {
      if (!this.slides.length) return;

      let target = index;
      if (target < 0) {
        target = this.slides.length - 1;
      } else if (target >= this.slides.length) {
        target = 0;
      }

      if (target === this.activeIndex) {
        return;
      }

      this.activeIndex = target;
      this.updateSlides();
    }

    updateSlides() {
      this.slides.forEach((slide, idx) => {
        const isActive = idx === this.activeIndex;
        slide.classList.toggle('is-active', isActive);
        controlSlideshowMedia(slide, isActive);
      });

      this.dots.forEach((dot, idx) => {
        const isActive = idx === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    destroy() {
      if (this.destroyed) return;
      if (this.prevBtn) {
        this.prevBtn.removeEventListener('click', this.onPrev);
      }
      if (this.nextBtn) {
        this.nextBtn.removeEventListener('click', this.onNext);
      }
      this.dots.forEach((dot) => {
        dot.removeEventListener('click', this.onDotClick);
      });
      this.slides.forEach((slide) => {
        controlSlideshowMedia(slide, false);
      });
      this.destroyed = true;
    }
  }

  function controlSlideshowMedia(slide, shouldPlay) {
    if (!slide) return;
    const video = slide.querySelector('[data-slideshow-video]');
    if (!video) return;

    if (shouldPlay) {
      if (video.readyState >= 2) {
        video.play().catch(() => {});
      } else {
        const onCanPlay = () => {
          video.play().catch(() => {});
          video.removeEventListener('canplay', onCanPlay);
        };
        video.addEventListener('canplay', onCanPlay);
      }
    } else {
      video.pause();
      video.currentTime = 0;
    }
  }

  const instances = new Map();

  function initSlideshows(scope = document) {
    const roots = scope.querySelectorAll('[data-animation-slideshow]');
    roots.forEach((root) => {
      if (instances.has(root)) return;
      const instance = new MtAnimationSlideshow(root);
      if (!instance.destroyed) {
        instances.set(root, instance);
      }
    });
  }

  function destroySlideshows(scope = document) {
    const roots = scope.querySelectorAll('[data-animation-slideshow]');
    roots.forEach((root) => {
      const instance = instances.get(root);
      if (instance) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSlideshows());
  } else {
    initSlideshows();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSlideshows(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroySlideshows(event.target);
  });
})();

